import uuid from '../utils/uuid.utils';

export class TokenEvent {
  static refresh() {
    const id = uuid();
    window.__CAAS__.triggerNative(window.__CAAS__.events.refreshToken, id, {});

    return id;
  }
}
